import axios from "axios";

export const getOptions = () => {
  return axios.get(`${process.env.VUE_APP_API_URL}/customers/options`);
};
